import { FormEvent, useState } from 'react';
import { signIn } from './auth';

export function SignIn({ onDone }: { onDone: () => void }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [needsNew, setNeedsNew] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    try {
      await signIn(email, password, needsNew ? newPassword : undefined);
      onDone();
    } catch (err) {
      const msg = (err as Error).message;
      if (msg === 'NEW_PASSWORD_REQUIRED') setNeedsNew(true);
      else setError(msg);
    }
  };

  return (
    <form className="signin" onSubmit={submit}>
      <h1>ngcc desk</h1>
      <input type="email" placeholder="email" value={email} onChange={(e) => setEmail(e.target.value)} autoFocus />
      <input type="password" placeholder="password" value={password} onChange={(e) => setPassword(e.target.value)} />
      {needsNew && <input type="password" placeholder="new password (12+ chars)" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />}
      {error && <p className="error">{error}</p>}
      <button type="submit">Sign in</button>
    </form>
  );
}
